import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { IMessagetype } from '../models/IMessagetype';
import { MessagesService } from '../Services/Messages/messages.service';
import { PatientSearchComponent } from '../patient-search/patient-search.component';
import { MatDialog, MatDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IPatientPharmacy } from '../models/IPatientPharmacy';
import { PersonalInfoService } from '../Services/Demographics/personal-info.service';
import { IUserDetails } from '../models/IUsersDetails';
import { SharedService } from '../Sharedservice/SharedService';
import { Observable } from 'rxjs';
import { IAttributes } from '../models/IAttributes';
import { startWith, map } from 'rxjs/operators';
import { RxService } from '../Services/NewVisitNote/rx.service';
import { IMessaging, IMessagingSender, IMessagingReceived } from '../models/IMessaging';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-new-create-request',
  templateUrl: './new-create-request.component.html',
  styleUrls: ['./new-create-request.component.css']
})
export class NewCreateRequestComponent implements OnInit {
  newRequestForm: FormGroup;
  public messageTypes: IMessagetype[];
  constructor(private messageService: MessagesService
    , public dialog: MatDialog
    , private formBuilder: FormBuilder
    , private personalService: PersonalInfoService
    , private sharedService: SharedService
    , private rxService: RxService
    , private toastr: ToastrService,
    public dialogRef: MatDialogRef<NewCreateRequestComponent>,
    private spinner: NgxSpinnerService, ) { }

  formErrors = {
    'provider': '',
    'patient': '',
    'request': '',
    'assign': '',
    'medications': '',
    'priority': '',
  };

  validationMessages = {
    'patient': {
      'required': 'Patient name is required.'
    },
    'request': {
      'required': 'Refill request is required.'
    },
    'assign': {
      'required': 'Assign To is required.'
    },
    'medications': {
      'required': 'Medications is required.'
    },
    'priority':{
      'required': 'Priority is required.'
    }
  };

  ngOnInit() {
    this.spinner.hide();

    this.newRequestForm = this.formBuilder.group({
      request: ['', Validators.required],
      patient: ['', Validators.required],
      dob: [''],
      assign: ['', Validators.required],
      medications: ['', Validators.required],
      //priority:['',Validators.required],
      priority:['']
      // practice: [''],
      // phone: [''],     
      // refill: [''],
      // pharmacy: [''],
    });
    this.newRequestForm.markAllAsTouched();
    this.newRequestForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.newRequestForm);
    });
    this.msgsender = new IMessagingSender;
    this.getRequestType();
    this.PopulateDropDownsBinding();
  }

  public providersDocList: IUserDetails[];
  public providersNurseList: IUserDetails[];
  public lstPriority: IAttributes[];
  getRequestType() {
    this.sharedService.getAllUsersByRole("Nurse").subscribe(data => {
      this.providersNurseList = data;
      this.sharedService.getAllUsersByRole("Doctor").subscribe(data => {
        this.providersDocList = data;
      });
    });

    this.messageService.getAllERxMessageTypes().subscribe(data => {
      this.messageTypes = data;
    },
      (err: any) => console.log(err)
    );

    this.messageService.getAllUsers().subscribe(data => {
      this.roles = data;
    },
      (err: any) => console.log(err)
    );

    this.sharedService.getAttributes().subscribe(data => {
      this.lstattrbutes = data;
      this.sharedService.lstattrbutes = this.lstattrbutes;
      if (this.sharedService.lstattrbutes != null && this.sharedService.lstattrbutes.length > 0) {
        this.lstPriority = this.sharedService.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '15');
      }
    });
  }

  patId: number = 0;
  patDOB = "";
  openPatSearchWindow(): void {
    sessionStorage.setItem("ispatSerachPopup", "True");
    const dialogRef = this.dialog.open(PatientSearchComponent, {
      width: 'auto',
       data: { action: true }
    }
    );
    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined && result != '') {
        this.patDOB = new DatePipe('en-US').transform(result.dob, 'MM/dd/yyyy')
        this.newRequestForm.patchValue({
          patient: result.name,
          phone: result.phone,
          dob: this.patDOB,
          assign: result.client
        });
        this.patId = result.patientId;
        if (this.patId != 0) {
          this.getPatPharmacyInfo(this.patId);
        }
        sessionStorage.removeItem("ispatSerachPopup");
      }
    });
  }

  lstPatPharmacies: IPatientPharmacy[] = [];
  getPatPharmacyInfo(id: number) {
    this.personalService.getPatPharmacyInfo(id)
      .subscribe(
        (data: any) => {
          this.lstPatPharmacies = data;
        },
        (err: any) => console.log(err)
      );
  }

  pharamID: any;
  onselectionMedicinechange(event, id, Name) {
    this.medID = id;
  }
  onselectionpharmacychange(event, id, Name) {
    this.pharamID = id;
  }

  lstattrbutes: IAttributes[] = [];
  public clerkNotes: IAttributes[] = [];
  PopulateDropDownsBinding() {
    this.rxService.getClerkMsgTemplatesDetails().subscribe((data: IAttributes[]) => {
      this.lstattrbutes = data;
      this.clerkNotes = this.lstattrbutes;
      this.sitefilter();
    });
  }

  lstMedicinesOptions: Observable<IAttributes[]>;
  public notesId: string;
  cmbnotes: string;
  sitefilter() {
    this.lstMedicinesOptions = this.newRequestForm.get('medications')!.valueChanges.pipe(
      startWith(""),
      map(value => this._site(value))
    );
  }
  private _site(value: string): IAttributes[] {
    const filterValue = value.toString().toLowerCase();
    return this.clerkNotes.filter(option => option.attributeName.toLowerCase().indexOf(filterValue) === 0);
  }

  logValidationErrors(group: FormGroup = this.newRequestForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid
          && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

  msgsender: IMessagingSender;
  filteruser: any[] = [];
  public roles: IUserDetails[];
  messaging: IMessaging = new IMessaging;
  msgreceived: IMessagingReceived[] = [];
  medID: any;
  createRequest() {
    this.spinner.show();
    this.MapValuesforSender();
    this.MapValuesforReceiver(this.roles.filter(a => a.userId == this.newRequestForm.value.assign));
    this.messaging.messagingSenders = this.msgsender;
    this.messaging.lstmessagingReceiveds = this.msgreceived;
    this.InsertMessage(this.messaging);

    (err: any) => {
      this.spinner.hide();
      console.log(err)
     
    }
  }

  MapValuesforSender() {
    this.filteruser = this.roles.filter(a => a.userId == sessionStorage.getItem("userId"));
    this.msgsender.senderId = 0;
    this.msgsender.senderUserID = sessionStorage.getItem("userId");
    this.msgsender.roleID = this.filteruser[0].roleId;
    this.msgsender.messageType = this.newRequestForm.value.request;
    this.msgsender.priority = this.newRequestForm.value.priority;
    this.msgsender.body = 'Patient';
    this.msgsender.isDeleted = false;
    this.msgsender.isVisible = false;
    this.msgsender.dbOpertion = "Insert";
    this.msgsender.createdBy = sessionStorage.getItem("userId");
    this.msgsender.createdOn = new Date;
    this.msgsender.messageName = "";
    this.msgsender.imageSource = "";
    this.msgsender.receiverUserID = this.newRequestForm.value.assign;
    this.msgsender.senderFullName = this.filteruser[0].userName;
    this.msgsender.receiverFullName = "";
    this.msgsender.amendmentId = 0;
    this.msgsender.amendmentStatus = "";
    this.msgsender.attachmentName = "";
    this.msgsender.attachment = "";
    this.msgsender.listUsersTo = this.newRequestForm.value.assign;
    this.msgsender.listUsersCC = "";
    this.msgsender.toOrCC = "";
    this.msgsender.patName = 'Provider Review';
    this.msgsender.patId = this.patId;
    this.msgsender.pharmacyId = this.pharamID;
    this.msgsender.medicationId = this.medID;
    this.msgsender.subject = this.newRequestForm.value.medications;
    this.filteruser.length = 0;
  }

  msgreceiver: IMessagingReceived;
  MapValuesforReceiver(user) {
    this.msgreceiver = new IMessagingReceived;
    this.msgreceiver.patName = this.newRequestForm.value.patient;
    this.msgreceiver.receiverID = 0;
    this.msgreceiver.senderID = 0;
    this.msgreceiver.listUsersTo = this.newRequestForm.value.assign;
    this.msgreceiver.listUsersCC = "";
    this.msgreceiver.toOrCC = "";
    this.msgreceiver.roleID = user[0].roleId;
    this.msgreceiver.receiverUserID = this.newRequestForm.value.assign;
    this.msgreceiver.dbOpertion = "Insert";
    this.msgreceiver.isActive = false;
    this.msgreceiver.isVisible = false;
    this.msgreceiver.isDeleted = false;
    this.msgreceiver.createdBy = sessionStorage.getItem("userId");
    this.msgreceiver.createdOn = new Date;
    this.msgreceiver.receiverFullName = user[0].userName;
    this.msgreceiver.attachmentName = "";
    this.msgreceiver.attachment = "";
    this.msgreceived.push(this.msgreceiver);
    this.msgreceiver = null;
  }

  result: string = "";
  InsertMessage(message: IMessaging) {
    
    this.messageService.insertSenderMessageDetails(message, sessionStorage.getItem("userId")).subscribe(data => {
      this.result = data;
      this.toastr.success(this.result);
      this.spinner.hide();
      this.reqCancel.emit(true);
      this.dialogRef.close();
    },
      (err: any) => {
        this.spinner.hide();
        console.log(err)
        this.result = err;
        this.toastr.error(this.result);
      }
    );
  }

  @Output() reqCancel  = new EventEmitter();
  onReqCancel(){
    this.reqCancel.emit(true);
    this.dialogRef.close();
  }
}
